import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import Select from '../common/AppSelect';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as carrerasService from '../../services/carreras/carrerasService';
import {
  classifyCarrerasError,
  toUpdateCarreraPayload,
  validateCarreraForm
} from '../../services/carreras/carrerasDto';
import { findSelectOptionByValue, YES_NO_OPTIONS } from '../../services/selectOptions';

const options = YES_NO_OPTIONS;

export class UpdateCarrera extends Component {
  static displayName = UpdateCarrera.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      id: this.props.match.params.id,
      details: this.props.match.params.details,
      anioImplementacion: "",
      name: "",
      showErrorMessage: false,
      success: false,
      errorMessage: "",
      resolucionMinisterial: "",
      extinta: "",
      value: null
    };
    this.handleConfirmButton = this.handleConfirmButton.bind(this);
    this.handleAnioImplementacion = this.handleAnioImplementacion.bind(this);
    this.handleNameChangeInput = this.handleNameChangeInput.bind(this);
    this.handleResolucionMinisterial = this.handleResolucionMinisterial.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWCarreras');
    if (canAccess) {
      this.populateData();
    }
  }

  handleConfirmButton = () => {
    if (this.state.details === "1") {
      this.setState({ success: true })
    } else {
      if (this.isOkToSave()) {
        this.saveCarrera();
      } else {
        this.setState({ showErrorMessage: true, errorMessage: "Todos los campos son obligatorios" });
      }
    }
  }

  handleAnioImplementacion = e => {
    this.setState({ anioImplementacion: e.target.value });
  }

  handleResolucionMinisterial = e => {
    this.setState({ resolucionMinisterial: e.target.value });
  }

  handleNameChangeInput = e => {
    this.setState({ name: e.target.value });
  }

  handleSelect = e =>
  {
    this.setState({extinta:e.value,value:e});
  }

  render() {
    if (this.state.success) {
      return <Redirect to="/md-carreras" />;
    }

    const isDetail = this.state.details !== '0';
    const title = isDetail ? 'Detalle de la Carrera' : 'Modificar Carrera';
    const { loading } = this.state;

    return (
      <div className="md-page md-update-carrera">
        <Link className="md-page__back-link" to="/md-carreras">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">{title}</h1>
        </div>
        <p className="md-page__subtitle">
          {isDetail
            ? 'Consulte los datos registrados de la carrera.'
            : 'Actualice los datos de la carrera y guarde los cambios.'}
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se está guardando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="carrera-nombre">
              Nombre Completo
            </label>
            {isDetail ? (
              <div className="md-page__field-readonly" id="carrera-nombre">{this.state.name}</div>
            ) : (
              <input
                id="carrera-nombre"
                className="md-page__field-input"
                name="name"
                placeholder="Ingrese Nombre Completo"
                onChange={this.handleNameChangeInput}
                disabled={loading}
                value={this.state.name}
                required
              />
            )}
          </div>

          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="carrera-anio">
              Año de Implementación
            </label>
            {isDetail ? (
              <div className="md-page__field-readonly" id="carrera-anio">{this.state.anioImplementacion}</div>
            ) : (
              <input
                id="carrera-anio"
                className="md-page__field-input md-page__field-input--year"
                name="anioImplementacion"
                placeholder="Ingrese Año Implementación"
                onChange={this.handleAnioImplementacion}
                disabled={loading}
                value={this.state.anioImplementacion}
              />
            )}
          </div>

          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="carrera-resolucion">
              Resolución Ministerial
            </label>
            {isDetail ? (
              <div className="md-page__field-readonly" id="carrera-resolucion">{this.state.resolucionMinisterial}</div>
            ) : (
              <input
                id="carrera-resolucion"
                className="md-page__field-input"
                name="resolucionMinisterial"
                placeholder="Ingrese Resolución de Aprobación"
                onChange={this.handleResolucionMinisterial}
                disabled={loading}
                value={this.state.resolucionMinisterial}
                required
              />
            )}
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Carrera Extinta</span>
            {isDetail ? (
              <div className="md-page__field-readonly">{this.state.extinta === 'N' ? 'No' : 'Sí'}</div>
            ) : (
              <Select
                className="md-page__field-select"
                value={this.state.value}
                options={options}
                onChange={this.handleSelect}
                isSearchable={false}
                disabled={loading}
              />
            )}
          </div>

          {!isDetail ? (
            <div className="md-page__form-actions">
              <button
                type="button"
                className="md-page__form-btn md-page__form-btn--primary"
                onClick={this.handleConfirmButton}
                disabled={loading}
              >
                Guardar cambios
              </button>
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  isOkToSave() {
    return validateCarreraForm({
      name: this.state.name,
      anioImplementacion: this.state.anioImplementacion,
      resolucionMinisterial: this.state.resolucionMinisterial,
      extinta: this.state.extinta
    });
  }

  async populateData() {
    try {
      const returnModel = await carrerasService.getCarrera(this.state.id);
      const defaultValue = findSelectOptionByValue(options, returnModel.carreraExtinta);
      this.setState({
        anioImplementacion: returnModel.carreraAnioImplementacion,
        name: returnModel.carreraNombre.trim(),
        extinta: returnModel.carreraExtinta,
        resolucionMinisterial: returnModel.carreraResolucionAprobacion.trim(),
        errorMessage: "",
        value: defaultValue
      });
    } catch (error) {
      const outcome = classifyCarrerasError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      const errorMessage = outcome.message;
      this.setState({ errorMessage });
    }
  }

  async saveCarrera() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await carrerasService.saveCarrera(
        toUpdateCarreraPayload({
          id: this.state.id,
          name: this.state.name,
          anioImplementacion: this.state.anioImplementacion,
          resolucionMinisterial: this.state.resolucionMinisterial,
          extinta: this.state.extinta
        })
      );
      this.setState({ loading: false, success: true, errorMessage: "" });
    } catch (error) {
      const outcome = classifyCarrerasError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      const errorMessage = outcome.message;
      this.setState({ loading: false, success: false, errorMessage });
    }
  }
}
